// Types
interface Type {
  credit: number
  debit: number
}

export function getSummary(data: Type[]): Type {
  return data.reduce((acc, item) => {
    return {
      credit: acc.credit + item.credit,
      debit: acc.debit + item.debit
    }
  }, {
    credit: 0,
    debit: 0
  })
}